"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("@empiriecom/module-components/utils/styled-components");
var ThemeDefault = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .inner {\n    height: 1px;\n\n    ", "\n\n    ", "\n  }\n"], ["\n  .inner {\n    height: 1px;\n\n    ",
    "\n\n    ",
    "\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.sectionSeparator.default.wrapper.boxShadow !== ''
        ? "box-shadow: " + component.sectionSeparator.default.wrapper.boxShadow + ";"
        : '';
}, function (_a) {
    var component = _a.theme.component;
    return component.sectionSeparator.default.wrapper.backgroundColor !== ''
        ? "background-color: " + component.sectionSeparator.default.wrapper.backgroundColor + ";"
        : '';
});
exports.default = ThemeDefault;
var templateObject_1;
//# sourceMappingURL=default.js.map